export interface CsvExportColumn<TRow> {
  /** Stable key for tests and future column toggles. */
  key: string
  /** Header cell shown in the first CSV row. */
  header: string
  getValue: (row: TRow) => string | number | boolean | null | undefined
}

const escapeCsvCell = (raw: string): string => {
  if (/[",\r\n]/.test(raw)) {
    return `"${raw.replace(/"/g, '""')}"`
  }
  return raw
}

const normalizeCell = (value: string | number | boolean | null | undefined): string => {
  if (value === null || value === undefined) return ""
  return String(value)
}

/** Build CSV text from rows using a column config. UTF-8 BOM included for Excel. */
export const buildCsv = <TRow>(
  rows: TRow[],
  columns: CsvExportColumn<TRow>[],
): string => {
  const headerLine = columns.map((col) => escapeCsvCell(col.header)).join(",")
  const bodyLines = rows.map((row) =>
    columns
      .map((col) => escapeCsvCell(normalizeCell(col.getValue(row))))
      .join(","),
  )
  return `\uFEFF${[headerLine, ...bodyLines].join("\r\n")}`
}

export const downloadCsv = (csvContent: string, filename: string): void => {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement("a")
  anchor.href = url
  anchor.download = filename
  anchor.style.display = "none"
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
